/* src/app/pages/info/tabs/info-privacy/info-privacy.page.scss */
/*# sourceMappingURL=info-privacy.page.css.map */
